import {
  getCheckoutResultsAction,
  getDeliveryTrackingLinkAction,
  verifyAuthenticateTokenAction
} from './action'
import { createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'

interface ThankyouState {
  checkoutResults: Oms.V4.CheckoutResults
  validateTokenResults: PlainInfo<Record<string, unknown>>
  trackingDeliveryResults: PlainInfo<Record<string, string>>
}

type Nullable<T> = T | null

type PlainInfo<T> = {
  status: RequestState
  error?: string
  data: Nullable<T>
}

type RequestState = 'pending' | 'fulfilled' | 'rejected' | 'none'

const initialState: ThankyouState = {
  checkoutResults: {
    status: 'none',
    data: {} as {
      storeOrder: Oms.V4.StoreOrder
    },
    error: null
  },
  validateTokenResults: {
    status: 'none',
    data: {},
    error: null
  },
  trackingDeliveryResults: {
    status: 'none',
    data: {},
    error: null
  }
}

export const thankyouSlice = createSlice({
  name: '@thankyou',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCheckoutResultsAction.pending, (state) => {
        state.checkoutResults.status = 'pending'
      })
      .addCase(getCheckoutResultsAction.fulfilled, (state, action) => {
        state.checkoutResults.status = 'fulfilled'
        state.checkoutResults.data = action.payload?.payload || {}
      })
      .addCase(getCheckoutResultsAction.rejected, (state, action) => {
        state.checkoutResults.status = 'rejected'
        state.checkoutResults.error = action.error.message
      })
      .addCase(verifyAuthenticateTokenAction.pending, (state) => {
        state.validateTokenResults.status = 'pending'
      })
      .addCase(verifyAuthenticateTokenAction.fulfilled, (state, action) => {
        state.validateTokenResults.status = 'fulfilled'
        state.validateTokenResults.data = action.payload.data
      })
      .addCase(verifyAuthenticateTokenAction.rejected, (state, action) => {
        state.validateTokenResults.status = 'rejected'
        state.validateTokenResults.error = action.error.message
      })
      .addCase(getDeliveryTrackingLinkAction.pending, (state) => {
        state.trackingDeliveryResults.status = 'pending'
      })
      .addCase(getDeliveryTrackingLinkAction.fulfilled, (state, action) => {
        state.trackingDeliveryResults.status = 'fulfilled'
        state.trackingDeliveryResults.data = action.payload?.data || {}
      })
      .addCase(getDeliveryTrackingLinkAction.rejected, (state, action) => {
        state.trackingDeliveryResults.status = 'rejected'
        state.trackingDeliveryResults.error = action.error.message
      })
      .addCase(HYDRATE, (state, action) => ({
        ...state,
        ...action['payload']['@thankyou']
      }))
  }
})
